import { useEffect } from 'react';

const footerLinks = [
  {
    title: 'Navegación',
    links: [
      { label: 'Inicio', href: '#inicio' },
      { label: 'Servicios', href: '#servicios' },
      { label: 'Cobertura', href: '#cobertura' },
      { label: 'Galería', href: '#galeria' },
      { label: 'Contacto', href: '#contacto' },
    ],
  },
  {
    title: 'Servicios',
    links: [
      { label: 'Transporte Empresarial', href: '#servicios' },
      { label: 'Transporte Industrial', href: '#servicios' },
      { label: 'Turismo y Renta', href: '#servicios' },
      { label: 'Servicios Nocturnos', href: '#servicios' },
    ],
  },
  {
    title: 'Contacto',
    links: [
      { label: 'ventas@yakistourist.com', href: 'mailto://ventas@yakistourist.com' },
      { label: '+52 4441951948', href: 'tel://+524441951948' },
      { label: 'WhatsApp', href: 'https://wa.me/524441951948' },
    ],
  },
];

export default function Footer() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('.footer-animate');
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-yakis-navy text-white pt-16 md:pt-24 pb-8">
      <div className="section-container">
        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 mb-16">
          {/* Brand Column */}
          <div className="footer-animate animate-on-scroll">
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://public.readdy.ai/ai/img_res/61a74797-87df-4251-bf99-e770eda51805.png"
                alt="Yakis"
                className="w-12 h-12 object-contain"
              />
              <span className="font-display font-bold text-2xl tracking-tight">
                YAKIS
              </span>
            </div>
            <p className="text-yakis-silver text-sm leading-relaxed mb-6">
              Más de 20 años transformando la movilidad empresarial en San Luis Potosí y Monterrey. 
              Seguridad, puntualidad y calidad en cada trayecto.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://wa.me/524441951948"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-yakis-gold transition-all duration-300 hover:scale-110"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-lg" />
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-yakis-gold transition-all duration-300 hover:scale-110"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg" />
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-yakis-gold transition-all duration-300 hover:scale-110"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-line text-lg" />
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-yakis-gold transition-all duration-300 hover:scale-110"
                aria-label="YouTube"
              >
                <i className="ri-youtube-line text-lg" />
              </a>
            </div>
          </div>

          {/* Link Columns */}
          {footerLinks.map((col) => (
            <div key={col.title} className="footer-animate animate-on-scroll">
              <h4 className="font-display font-semibold text-sm uppercase tracking-wider mb-5 text-yakis-gold">
                {col.title}
              </h4>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        if (link.href.startsWith('#')) {
                          e.preventDefault();
                          scrollTo(link.href);
                        }
                      }}
                      target={link.href.startsWith('http') ? '_blank' : undefined}
                      rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                      className="text-sm text-yakis-silver hover:text-white transition-colors duration-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-yakis-silver">
              &copy; 2024 Yakis Transporte Empresarial. Todos los derechos reservados.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-yakis-silver hover:text-white transition-colors">
                Política de Privacidad
              </a>
              <a href="#" className="text-xs text-yakis-silver hover:text-white transition-colors">
                Términos de Servicio
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}